<template>
  <vue-editor v-model="content"></vue-editor>
</template>

<script>
  import {VueEditor} from "vue2-editor/dist/vue2-editor.core"

  export default {
    name: "editor",
    components: {
      VueEditor,
    },
    props: {
      content: {
        type: String,
        default: '',
      }
    },
    watch: {
      'content': {
        handler(value) {
          this.$emit('change', value)
        }
      },
    }
  }
</script>

<style lang="css">
  @import "~vue2-editor/dist/vue2-editor.css";

  /* Import the Quill styles you want */
  @import '~quill/dist/quill.core.css';
  @import '~quill/dist/quill.bubble.css';
  @import '~quill/dist/quill.snow.css';
</style>
